import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  NbAuthComponent,
  NbLoginComponent, 
  NbLogoutComponent,
} from '@nebular/auth';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivateChild: [AuthGuard],
    loadChildren: async () => (await import('./modules/dashboard/dashboard.module')).DashboardModule,
  },
  {
    path: 'users',
    canActivateChild: [AuthGuard],
    loadChildren: async () => (await import('./modules/user/user.module')).UserModule,
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'logout',
        component: NbLoginComponent,
      }
    ],
  },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
